import { cn } from '@exam-room/utils';

import { RadioButton } from '../radio-button';

type SatisfactionField = 'location' | 'staffServices' | 'systemUsability' | 'systemStability';

interface ExamCenterSatisfactionRowProps {
  field: SatisfactionField;
  label: string;
  columns: { label: string; value: string }[];
  gridClassName: string;
}

export default function ExamCenterSatisfactionRow(props: Readonly<ExamCenterSatisfactionRowProps>) {
  const { field, label, columns, gridClassName } = props;

  return (
    <div className={cn(gridClassName, 'py-2')}>
      <label htmlFor={`examinationSatisfaction.${field}`} className='pr-4'>
        {label}
      </label>
      {columns.map((column) => (
        <div key={field + column.value} className='flex justify-center'>
          <RadioButton
            id={`examinationSatisfaction.${field}.${column.value}`}
            name={`examinationSatisfaction.${field}`}
            value={column.value}
          />
        </div>
      ))}
    </div>
  );
}
